/* esm.sh - applesauce-common@5.2.0/dist/blueprints/share */
export * from "/*applesauce-common@5.2.0/esnext/dist/blueprints/share.mjs";
